// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"gameOptionDropdown_fullWidth__V1v9b"};